var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "profit_setting" } },
    [
      _c("dd-header", { ref: "menuRef", attrs: { headerType: 2 } }),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("dd-sitemap", {
                  attrs: {
                    pageKey: _vm.pageKey,
                    pageList: _vm.pageList,
                    mapStyle: "topic_path"
                  }
                }),
                _vm._v(" "),
                _c("div", { attrs: { id: "profit_area" } }, [
                  _c("h2", { staticClass: "title" }, [
                    _vm._v("お客様価格表示")
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _c("section", { attrs: { id: "setting" } }, [
                    _c("div", { staticClass: "setting_param" }, [
                      _c("h2", [_vm._v("販売価格率の設定")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "profit_input_field" }, [
                        _c("div", [_vm._v("商品価格")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.profitPercentProduct,
                              expression: "profitPercentProduct"
                            }
                          ],
                          staticClass: "profit_input",
                          attrs: {
                            type: "text",
                            oninput: "if(value.length>3)value=value.slice(0,3)",
                            disabled: !_vm.isAdmin
                          },
                          domProps: { value: _vm.profitPercentProduct },
                          on: {
                            keypress: _vm.validateNumber,
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.profitPercentProduct = $event.target.value
                              },
                              function($event) {
                                _vm.profitPercentProduct = _vm.convertHalfNumber(
                                  $event
                                )
                              }
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("div", [_vm._v("%")])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "profit_input_field" }, [
                        _c("div", [_vm._v("組立設置費")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.profitPercentConstruct,
                              expression: "profitPercentConstruct"
                            }
                          ],
                          staticClass: "profit_input",
                          attrs: {
                            type: "text",
                            oninput: "if(value.length>3)value=value.slice(0,3)",
                            disabled: !_vm.isAdmin
                          },
                          domProps: { value: _vm.profitPercentConstruct },
                          on: {
                            keypress: _vm.validateNumber,
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.profitPercentConstruct = $event.target.value
                              },
                              function($event) {
                                _vm.profitPercentConstruct = _vm.convertHalfNumber(
                                  $event
                                )
                              }
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("div", [_vm._v("%")])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "profit_input_field" }, [
                        _c("div", [_vm._v("事前現場調査費")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.profitPercentResearch,
                              expression: "profitPercentResearch"
                            }
                          ],
                          staticClass: "profit_input",
                          attrs: {
                            type: "text",
                            oninput: "if(value.length>3)value=value.slice(0,3)",
                            disabled: !_vm.isAdmin
                          },
                          domProps: { value: _vm.profitPercentResearch },
                          on: {
                            keypress: _vm.validateNumber,
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.profitPercentResearch = $event.target.value
                              },
                              function($event) {
                                _vm.profitPercentResearch = _vm.convertHalfNumber(
                                  $event
                                )
                              }
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("div", [_vm._v("%")])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(2),
                  _vm._v(" "),
                  _c("div", { staticClass: "profit_btn" }, [
                    _c(
                      "div",
                      {
                        staticClass: "main_btn sel_main_btn",
                        on: {
                          click: function($event) {
                            _vm.apply()
                          }
                        }
                      },
                      [_c("a", [_vm._v("反映する")])]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("dd-loading-modal", { ref: "loadingModalRef" })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("ul", { staticClass: "profit_list" }, [
        _c("li", [_vm._v("設定した販売価格率で価格を表示する機能です。")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "カスタマイズ画面、図面/見積りダイアログの価格が販売価格となります。"
          )
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("＊カート画面以降はネット価格です。")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("ul", { staticClass: "profit_list" }, [
        _c("li", { staticStyle: { "font-weight": "bold" } }, [
          _vm._v("※ 注意事項 ※")
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("1.カート画面より出力される見積り書は"),
          _c("span", { staticClass: "pickup" }, [_vm._v("ネット価格が表示")]),
          _vm._v("されます。")
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("2.販売価格率の設定は管理者権限が必要です。")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("ul", { staticClass: "profit_list" }, [
        _c("li", [_vm._v("※ 計算説明")]),
        _vm._v(" "),
        _c("li", [
          _vm._v("販売価格率が"),
          _c("span", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v("130%")
          ]),
          _vm._v("の場合、ネット価格が"),
          _c("span", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v("10,000円")
          ]),
          _vm._v("（税抜）であれば、")
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("表示価格は "),
          _c("span", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v("13,000円")
          ]),
          _vm._v("（税抜）となります。")
        ]),
        _vm._v(" "),
        _c("li", [_c("br")]),
        _vm._v(" "),
        _c("li", [_vm._v("商品価格⇒商品価格、配送料に適用")]),
        _vm._v(" "),
        _c("li", [_vm._v("組立設置費⇒組立技術料に適用")]),
        _vm._v(" "),
        _c("li", [_vm._v("事前現場調査費⇒事前現場調査費に適用")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b1d4780", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b1d4780","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/pages/DcProfitSetting.vue
// module id = null
// module chunks = 